export const pathToModel = (model = null, slug = '') => {
  if (model === 'post') {
    return `/news/${slug}`;
  } else if (model === 'person') {
    return `/organisation/${slug}`;
  } else if (model === 'position') {
    return `/positions/${slug}`;
  } else if (model === 'podcast') {
    return `/podcast/${slug}`;
  } else if (model === 'resolution') {
    return `/resolutions/${slug}`;
  } else if (model === 'job_opportunity') {
    return `/job-opportunity/${slug}`;
  } else if (model === 'event') {
    return `/events/${slug}`;
  } else if (model === 'press_release') {
    return `/press-releases/${slug}`;
  } else if (model === 'tag_news') {
    return `/news/${slug}`;
  } else if (model === 'candidate') {
    return `/leading-candidates/${slug}`;
  } else if (model === 'tender') {
    return `/tenders/${slug}`;
  } else {
    return '/' + slug;
  }
};

export const basePathTag = (model) => {
  if (model === 'podcast') {
    return '/podcast/';
  } else if (model === 'post') {
    return '/news/';
  } else if (model === 'press_release') {
    return '/news/';
  } else {
    return '';
  }
};

export const isArray = (array) => {
  return Array.isArray(array) && array.length > 0;
};

export const getCtaUrl = (cta, log) => {
  if (!cta) return;

  if (typeof cta === 'string') {
    return pathToModel(null, cta);
  }

  if (cta?.content?.model) {
    const { apiKey: model } = cta.content?.model;
    return pathToModel(model, cta.content?.slug);
  }

  if (cta?.link?.content?.model) {
    const { apiKey: model } = cta.link?.content?.model;
    return pathToModel(model, cta.link?.content?.slug);
  }

  const url = cta.link?.content ? '/' + cta.link?.content?.slug : cta.link?.url;
  return url;
};

export const getCtaTitle = (cta) => {
  return cta.title ? cta.title : cta.link?.content?.label;
};

export const getPhoneLink = (phone) => {
  return `tel:${phone}`;
};

export const getEmailLink = (email) => {
  return `mailto:${email}`;
};

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const isActiveTrail = (pathname, link) => {
  if (!pathname) return;

  const explodePath = pathname?.split('/') || [];
  if (pathname === link + '/' || explodePath.includes(link.substring(1))) {
    return true;
  }
  return false;
};

export const removeUnderscoreFromString = (string) => {
  return string.replaceAll('_', ' ');
};

export const truncate = (text, limit = 30) => {
  return text.slice(0, limit).concat('...');
};

// Policy papers filters
export const DATE_FILTERS = [
  {
    label: 'Any time',
    value: 'all',
  },
  {
    label: 'Last six months',
    value: 'last_six_months',
  },
  {
    label: 'Last month',
    value: 'last_month',
  },
  {
    label: 'Last year',
    value: 'last_year',
  },
  {
    label: 'Between dates',
    value: 'between_dates',
  },
];

export const filterPolicyPapersByLastMonth = (list) => {
  const currentDate = new Date();
  const lastMonthLastDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

  return list.filter((item) => {
    const itemDate = new Date(item.node.date);
    return itemDate >= lastMonthLastDay && itemDate <= currentDate;
  });
};

export const filterPolicyPapersByLastSixMonths = (list) => {
  const currentDate = new Date();
  const lastSixMonths = new Date(currentDate.getFullYear(), currentDate.getMonth() - 5, 1);

  return list.filter((item) => {
    const itemDate = new Date(item.node.date);
    return itemDate >= lastSixMonths && itemDate <= currentDate;
  });
};

export const filterPolicyPapersByLastYear = (list) => {
  const currentDate = new Date();
  const lastYear = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());

  return list.filter((item) => {
    const itemDate = new Date(item.node.date);
    return itemDate >= lastYear && itemDate <= currentDate;
  });
};

export const filterPolicyPapersByDateRange = (list, startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  return list.filter((item) => {
    const itemDate = new Date(item.node.date);
    return itemDate >= start && itemDate <= end;
  });
};

export function capitalizeFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatDateTime(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatDateToLongEnglish(dateString) {
  const date = new Date(dateString);

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const dayOfWeek = days[date.getUTCDay()];
  const dayOfMonth = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  const getOrdinalSuffix = (n) => {
    if (n > 3 && n < 21) return 'th'; // 11th, 12th, 13th
    switch (n % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  return `${dayOfWeek}, ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)} of ${month} ${year}`;
}
